export function getApiBase(): string {
  const raw = process.env.REACT_APP_API_URL || "";
  const trimmed = raw.replace(/\/$/, "");
  if (!trimmed) return "/api";
  return trimmed.endsWith("/api") ? trimmed : trimmed + "/api";
}

export const API_BASE = getApiBase();
